import { render, staticRenderFns } from "./NewEntity.vue?vue&type=template&id=55786ba3&scoped=true"
import script from "./NewEntity.vue?vue&type=script&lang=js"
export * from "./NewEntity.vue?vue&type=script&lang=js"
import style0 from "./NewEntity.vue?vue&type=style&index=0&id=55786ba3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55786ba3",
  null
  
)

export default component.exports